module.exports = __webpack_public_path__ + "static/media/facebook-social-media-social-network-svgrepo-com.35fa98f3.svg";